<template>
  <product-performance :value="adaptedValue" :is-mop="isMop"></product-performance>
</template>

<script>
// "Indicatori di performance" (PerformanceIndicators). Uses
// components/ProductDetails/ProductPerformance.vue (prop-driven, read-only display, no
// Vuex/parent coupling).
//
// Unlike RiskProfile/CostsProfile/PerformanceScenarios, this adapter is almost a pure passthrough:
// PerformanceIndicatorsPayload.Indicators/IndicatorsMax/BreakEven/BreakEvenMop use
// the field names and shapes ProductPerformance.vue expects
// (down to the `sharpeRationOnRiskFree` typo in its own `percentageFields` list, which must stay
// as is to keep matching the payload).
// The only real work is reshaping the payload's flat {indicators, indicatorsMax, breakEven,
// breakEvenMop} into the component's nested `value = {performance: {min, max}, breakEven, rhp}`.
//
// `rhp` (the KID RHP plotline on the break-even chart) comes from PerformanceIndicatorsPayload.Rhp.
import ProductPerformance from '../../ProductDetails/ProductPerformance'

export default {
  name: 'performance-indicators-section',
  components: {
    ProductPerformance,
  },
  props: {
    payload: { type: Object, required: true },
  },
  computed: {
    isMop() {
      return this.payload.indicatorsMax != null
    },
    adaptedValue() {
      return {
        performance: {
          min: this.payload.indicators,
          max: this.payload.indicatorsMax,
        },
        breakEven: this.isMop ? this.payload.breakEvenMop : this.payload.breakEven,
        rhp: this.payload.rhp,
      }
    },
  },
}
</script>
